<template>
    <div v-if="data.details.status_type && data.details.status_type === 'message'">
        <div v-if="data.details.type.toLowerCase() == 'successful'"
            :class="data.details.type.toLowerCase() == 'successful' ? 'active' : ''" id="pay-success" ref="success"
            class="opt-content-wrapper  pay-pane active py-4 px-3">
            Yes
            <h3 class="mt-2 text-center gray text-bold h3 mb-5" v-html="data.details.message"></h3>

            <div class="modal-body">
                <div class="row m-0">
                    <div class="col-12 px-0">
                        <div class="form-group mb-0">
                            <button type="submit" class="btn app-bg-color" :style="button_color"
                                @click.prevent="continueToMerchant">
                                {{ client_info.merchant.return_text || 'Back to merchant' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>

        <div v-if="data.details.type.toLowerCase() == 'successful'"
            :class="data.details.type.toLowerCase() == 'successful' ? 'active' : ''" id="pay-success" ref="success"
            class="opt-content-wrapper  pay-pane active p-4">
            <div class="text-center">
                <i class="title-icon success"></i>
            </div>

            <h3 class="text-center">Payment Successful</h3>

            <p class="mb-4"> {{ data.details.message || 'Congratulations your payment was successfully completed' }}.</p>

            <div class="modal-body">
                <div class="row m-0">
                    <div class="col-12 px-0">
                        <div class="form-group mb-0">
                            <button type="submit" class="btn app-bg-color" :style="button_color"
                                @click.prevent="continueToMerchant">
                                {{ client_info.merchant.return_text || 'Back to merchant' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div v-else-if="data.details.type.toLowerCase() == 'processing'"
            :class="data.details.type.toLowerCase() == 'processing' ? 'active' : ''" id="pay-success" ref="success"
            class="opt-content-wrapper  pay-pane active p-4">
            <div class="text-center">
                <i class="title-icon warning"></i>
            </div>

            <h3 class="text-center">Payment Processing</h3>

            <p class="mb-4"> {{ data.details.message || 'Your payment is processing' }}.</p>

            <div class="modal-body">
                <div class="row m-0">
                    <div class="col-12 px-0">
                        <div class="form-group mb-0">
                            <button type="submit" class="btn app-bg-color" :style="button_color"
                                @click.prevent="continueToMerchant">
                                {{ client_info.merchant.return_text || 'Back to merchant' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div v-else-if="data.details.type.toLowerCase() == 'pendingfulfilment' || data.details.type.toLowerCase() == 'pendingvalidation'"
            :class="data.details.type.toLowerCase() == 'pendingfulfilment' ? 'active' : ''" id="pay-success" ref="success"
            class="opt-content-wrapper  pay-pane active p-4">
            <div class="text-center">
                <i class="title-icon warning"></i>
            </div>

            <h3 class="text-center">Payment awaiting confirmation</h3>

            <p class="mb-4"> {{ data.details.message || 'Your payment is processing' }}.</p>

            <div class="modal-body">
                <div class="row m-0">
                    <div class="col-12 px-0">
                        <div class="form-group mb-0">
                            <button type="submit" class="btn app-bg-color" :style="button_color"
                                @click.prevent="continueToMerchant">
                                {{ client_info.merchant.return_text || 'Back to merchant' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else-if="data.details.type == 'error' || data.details.type.toLowerCase() == 'failed'" id="pay-failed"
            ref="failed"
            :class="data.details.type.toLowerCase() == 'failed' || data.details.type == 'error' ? 'active' : ''"
            class="opt-content-wrapper pay-pane active active p-4">

            <div class="text-center">
                <i class="title-icon error"></i>
            </div>

            <h3 class="text-center">Payment Failed</h3>

            <p class="mb-4">Opps... your payment has failed to complete.</p>

            <div class="modal-body">

                <div class="row m-0">
                    <div class="col-12 px-0">
                        <div v-if="data.details.failedFromStart == 'false' || !data.details.failedFromStart"
                            class="form-group text-center mb-2 mt-3">
                            <button type="button" class="btn app-bg-color" :style="button_color" @click.prevent="tryAgain">
                                Try Again</button>
                        </div>

                        <div class="form-group text-center mb-0 mt-4">
                            <a href="javascript:void(0)" style="font-size : 14px !important; text-decoration:none"
                                class="text-tiny" @click.prevent="continueToMerchant"> &larr; {{
                                    client_info.merchant.return_text || 'Back to merchant' }}</a>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div v-else-if="data.details.type == 'warning'" id="pay-warning" ref="warning"
            :class="data.details.type == 'warning' || data.details.type == 'Warning' ? 'active' : ''"
            class="opt-content-wrapper pay-pane active p-4">

            <div class="text-center">
                <i class="title-icon warning"></i>
            </div>

            <h3 class="text-center">{{ data.details.heading }}</h3>

            <p class="mb-4">{{ data.details.message }}</p>

            <div class="modal-body">
                <div class="row m-0">
                    <div class="col-12 px-0">
                        <div v-if="data.details.failedFromStart == 'false' || !data.details.failedFromStart"
                            class="form-group text-center mb-2 mt-3">
                            <button type="button" class="btn app-bg-color" :style="button_color" @click.prevent="tryAgain">
                                Try Again</button>
                        </div>

                        <div class="form-group text-center mb-0 mt-4">
                            <a href="javascript:void(0)" style="font-size : 14px !important; text-decoration:none"
                                class="text-tiny" @click.prevent="continueToMerchant"> &larr; {{
                                    client_info.merchant.return_text || 'Back to merchant' }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else id="pay-warning" ref="warning" :class="data.details.type == 'warning' ? 'active' : ''"
            class="opt-content-wrapper pay-pane active p-4">

            <div class="text-center">
                <i class="title-icon warning"></i>
            </div>

            <h3 class="text-center">Payment Canceled</h3>

            <p class="mb-4">Oops... your payment was canceled before completion or must have been completed.</p>

            <div class="modal-body">
                <!-- <form class="form" action="" method=""> -->
                <div class="row m-0">
                    <div class="col-12 px-0">
                        <div v-if="data.details.failedFromStart == 'false' || !data.details.failedFromStart"
                            class="form-group text-center mb-2 mt-3">
                            <button type="button" class="btn app-bg-color" :style="button_color" @click.prevent="tryAgain">
                                Try Again</button>
                        </div>

                        <div class="form-group text-center mb-0 mt-4">
                            <a href="javascript:void(0)" style="font-size : 14px !important; text-decoration:none"
                                class="text-tiny" @click.prevent="continueToMerchant"> &larr; {{
                                    client_info.merchant.return_text || 'Back to merchant' }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'status',
    props: {
        data: Object,
        appColor: String,
        message: String,
        button_color: Object,
        client_info: Object,
    },
    created() {
        // var res = JSON.parse(window.raw) //JSON.parse(localStorage.raw);
        let data = this.data.details;

        if (data.data)
            delete data.data.client_info;

        let paymentMethod = this.$store.state.paymentMethod.toLowerCase();
        // let paymentMethodProvider = this.$store.state.paymentMethodProvider;
        let autoClose = this.$parent.hasAutoClose(paymentMethod, data.type)
        if (autoClose && autoClose.status) {
            setTimeout(() => {
                this.$parent.continueToMerchant({
                    data: data.data,
                    message: (this.data.details.status_type && this.data.details.status_type === 'message') ? 'Service will be provided upon confirmation of payment.' : data.message,
                    // status: data.type,
                    status: (this.data.details.status_type && this.data.details.status_type === 'message') ? 'PendingFulfilment' : data.type,
                });
            }, autoClose.timeout * 1000)
            return;
        }
    },
    methods: {
        tryAgain() {
            this.$router.push('/v2/popup');
            let ref = Date.now() + (Math.floor(Math.random() * 1000)).toString()
            const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef()}`;
            this.$store.dispatch('transRef', newRef);
            this.$store.dispatch('isFailed', true);
            this.loading = false;
        },

        continueToMerchant() {
            if (!window.raw) {
                return;
            }
            var res = JSON.parse(window.raw);
            // console.log(res);
            delete res.client_info;
            delete res.paymentoptions;
            this.$parent.continueToMerchant({
                message: (this.data.details.status_type && this.data.details.status_type === 'message') ? 'Service will be provided upon confirmation of payment.' : res.message,
                status: (this.data.details.status_type && this.data.details.status_type === 'message') ? 'PendingFulfilment' : res.status || res.status,
                data: res.data,
            });
        },
    }
};
</script>
